const format = (value: number, decimalPlaces: number = 2, literal: boolean = false): string => {
    let num: number = +value;

    // If the value is not a number, default to 0
    if (isNaN(num)) {
        num = 0;
    }

    // Multiply by 100 if needed and truncate to specified decimal places
    const adjusted = literal ? num : num * 100;
    const percent = adjusted.toFixed(decimalPlaces);

    return `${percent}%`;
};

export type PercentFilter = (value: number, decimalPlaces?: number, literal?: boolean) => string;

const percentFilter = (): PercentFilter => format;

export { percentFilter };
